import { createAction, props } from '@ngrx/store';

import { SystemConfigurationsMobileSettingsResponse } from '../../typings/system-configurations';

export const authenticateDataProvider = createAction(
  '[Data Provider] Authenticate Data Provider',
  props<{
    payload: {
      data: {
        password: string;
        username: string;
      };
      isOnboardingFlow: boolean;
    };
  }>()
);

export const authenticateDataProviderSuccess = createAction(
  '[Data Provider] Authenticate Data Provider Success',
  props<{
    payload: {
      data: {
        password: string | null;
        username: string | null;
      };
      isOnboardingFlow: boolean;
    };
  }>()
);

export const authenticateDataProviderFailure = createAction(
  '[Data Provider] Authenticate Data Provider Failure',
  props<{ payload: { error: Error } }>()
);

export const authenticateDataProviderPasswordExpired = createAction(
  '[Data Provider] Authenticate Data Provider Password Expired',
  props<{ payload: { isOnboardingFlow: boolean; username: string } }>()
);

export const authenticateDataProviderReset = createAction('[Data Provider] Authenticate Data Provider Reset');

export const updateDataProviderAuthentication = createAction(
  '[Data Provider] Update Data Provider Authentication',
  props<{
    payload: {
      code: string;
      data: SystemConfigurationsMobileSettingsResponse;
      password: string | null;
      username: string | null;
    };
  }>()
);

export const changePassword = createAction(
  '[Data Provider] Change Password',
  props<{
    payload: {
      isOnboardingFlow: boolean;
      newPassword: string | null;
      oldPassword: string | null;
    };
  }>()
);

export const changePasswordSuccess = createAction(
  '[Data Provider] Change Password Success',
  props<{
    payload: {
      newPassword: string | null;
    };
  }>()
);

export const changePasswordFailure = createAction(
  '[Data Provider] Change Password Failure',
  props<{ payload: { error: Error } }>()
);
